var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQrCodeScan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Qr_code_scan_-_Free_technology_icons-2",
    "data-name": "Qr code scan - Free technology icons-2",
    transform: "translate(0 -0.362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9454",
    "data-name": "Group 9454",
    transform: "translate(0 0.362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9453",
    "data-name": "Group 9453"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9599",
    "data-name": "Path 9599",
    d: "M9.563.362H2.384A2.374,2.374,0,0,0,0,2.742V9.923a2.394,2.394,0,0,0,2.384,2.4h7.18a2.407,2.407,0,0,0,2.4-2.4V2.742A2.388,2.388,0,0,0,9.563.362ZM9.8,9.883a.284.284,0,0,1-.285.284H2.352a.284.284,0,0,1-.284-.284V2.715a.284.284,0,0,1,.284-.284H9.519a.284.284,0,0,1,.285.284V9.883Z",
    transform: "translate(0 -0.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4812",
    "data-name": "Rectangle 4812",
    width: 4.588,
    height: 4.587,
    transform: "translate(3.687 3.688)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9600",
    "data-name": "Path 9600",
    d: "M9.563,19.072H2.384A2.37,2.37,0,0,0,0,21.447v7.182a2.4,2.4,0,0,0,2.384,2.408h7.18a2.412,2.412,0,0,0,2.4-2.408V21.447A2.384,2.384,0,0,0,9.563,19.072Zm.24,9.552a.247.247,0,0,1-.269.254H2.373a.278.278,0,0,1-.305-.254V21.461a.334.334,0,0,1,.305-.32H9.535a.306.306,0,0,1,.269.32v7.163Z",
    transform: "translate(0 -0.793)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4813",
    "data-name": "Rectangle 4813",
    width: 4.588,
    height: 4.588,
    transform: "translate(3.687 21.976)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9601",
    "data-name": "Path 9601",
    d: "M20.991,12.326h7.181a2.418,2.418,0,0,0,2.411-2.4V2.742A2.4,2.4,0,0,0,28.172.362H20.991a2.364,2.364,0,0,0-2.372,2.38V9.923A2.384,2.384,0,0,0,20.991,12.326Zm-.3-9.611a.284.284,0,0,1,.284-.284H28.14a.284.284,0,0,1,.283.284V9.883a.284.284,0,0,1-.283.284H20.972a.284.284,0,0,1-.284-.284Z",
    transform: "translate(-0.266 -0.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4814",
    "data-name": "Rectangle 4814",
    width: 4.676,
    height: 4.587,
    transform: "translate(21.957 3.688)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9602",
    "data-name": "Path 9602",
    d: "M4.3,13.675H2.716a.651.651,0,0,0-.647.633v1.583a.678.678,0,0,0,.647.663H4.227v.02a.582.582,0,0,0,.589.609H8.365v.075a.665.665,0,0,0,.651.645H10.6a.658.658,0,0,0,.644-.645V15.724a.629.629,0,0,0-.644-.61H9.8v-.806a.628.628,0,0,0-.621-.633H8.332a.609.609,0,0,0-.6.633v.807H4.946v-.807A.651.651,0,0,0,4.3,13.675Z",
    transform: "translate(0 -0.61)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9603",
    "data-name": "Path 9603",
    d: "M14.391,7.108v3.508a.594.594,0,0,0,.583.63h2.267a.659.659,0,0,0,.659-.63V9.033a.691.691,0,0,0-.659-.666h-.78V3.51h.1a.613.613,0,0,0,.624-.611v-.85a.609.609,0,0,0-.624-.607h-3a.594.594,0,0,0-.606.607V2.9a.6.6,0,0,0,.606.611h.833V5.759h-.833a.618.618,0,0,0-.606.636v.118a.584.584,0,0,0,.606.595Z",
    transform: "translate(-0.153 -0.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9604",
    "data-name": "Path 9604",
    d: "M16.1,14.4V12.86a.625.625,0,0,0-.625-.625H13.937a.625.625,0,0,0-.625.625V14.4a.625.625,0,0,0,.625.625h1.539A.625.625,0,0,0,16.1,14.4Z",
    transform: "translate(-0.149 -0.576)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9605",
    "data-name": "Path 9605",
    d: "M18.832,14.935a.673.673,0,0,0-.662.643V16.2a14.441,14.441,0,0,1,1.716-1.261H18.832Z",
    transform: "translate(-0.199 -0.615)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9606",
    "data-name": "Path 9606",
    d: "M18.008,16.374H15.316a.646.646,0,0,0-.654.62v3.6A15.964,15.964,0,0,1,17.328,17,8.188,8.188,0,0,1,18.008,16.374Z",
    transform: "translate(-0.167 -0.661)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9607",
    "data-name": "Path 9607",
    d: "M44.627,40.194,38.74,34.308a12.871,12.871,0,1,0-4.07,4.07l5.887,5.888a2.879,2.879,0,1,0,4.07-4.072Zm-10.15-6.067a9.4,9.4,0,1,1,0-13.3A9.409,9.409,0,0,1,34.477,34.127Z",
    transform: "translate(-0.479 -1.118)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeScan);
export default __webpack_public_path__ + "static/media/qr-code-scan.0da831cc1d537fc31090341f0203ef90.svg";
export { ForwardRef as ReactComponent };